
import {translate} from '@elements/translations';
import {ref, watch, defineComponent} from 'vue';
import LoadingSpinner from '~vue/components/loading/LoadingSpinner.vue';
import ModalHeader from "./FullscreenModalHeader.vue";
import ModalFooter from "./FullscreenModalFooter.vue";
import {storeToRefs} from 'pinia';
import {useTicketStore} from '~vue/stores/TicketStore.ts';

export default defineComponent({
    components: {
        ModalHeader,
        ModalFooter,
        LoadingSpinner
    },
    props: {
        config: {
            type: Object
        },
        stepViews: {
            type: Array,
            required: true
        },
        step: {
            type: Number,
            required: true
        },
        steps: {
            type: Number,
            required: true
        },
        buttonConfig: {
            type: Object,
            required: true
        },
        editMode: {
            type: Boolean,
            required: false,
            default: false
        },
        total: {
            type: Number,
            required: false
        }
    },
    emits: ["addToCart", "close"],
    setup(props, {emit}) {
        const modalRef = ref(null);
        const isLoading = ref<boolean>(true);

        const ticketStore = useTicketStore();
        const {
            showModal
        } = storeToRefs(ticketStore);
        const {changeShowModal} = ticketStore;

        const close = () => {
            document.getElementsByTagName('body')[0].classList.remove('no-scroll');
            changeShowModal(false);
            emit('close');
        };

        const show = () => {
            document.getElementsByTagName('body')[0].classList.add('no-scroll');
            changeShowModal(true);
            isLoading.value = true;
        };

        return {
            modalRef,
            showModal,
            close,
            show,
            emit,
            translate
        };
    },
});
